import { FaMobileAlt, FaProjectDiagram } from "react-icons/fa";
import { GrServices } from "react-icons/gr";
import { IoIosHome } from "react-icons/io";
import {
  MdOutlineFeaturedPlayList,
  MdOutlineImportContacts,
} from "react-icons/md";
import { NavLink } from "react-router-dom";
import { Row } from "../../Tools/Grid-system";
import { useContextHook } from "../../Context/ContextOPen";

const NavFooter = () => {
  const { content, direction } = useContextHook();
  const nav = [
    { id: 0, name: content.Home, link: "/", icon: IoIosHome },
    {
      id: 2,
      name: content.AboutUs,
      link: "/about-us",
      icon: MdOutlineImportContacts,
    },
    { id: 5, name: content.Projects, link: "/projects", icon: FaProjectDiagram },
    { id: 4, name: content.Services, link: "/services", icon: GrServices },
    {
      id: 3,
      name: content.Features,
      link: "/features",
      icon: MdOutlineFeaturedPlayList,
    },
    { id: 1, name: content.ContactUs, link: "/contact-us", icon: FaMobileAlt },
  ];
  return (
    <Row
      style={{ direction: direction }}
      className="items-center text-2xl shadowTop py-2 mx-auto overflow-hidden h-[10dvh] lg:!hidden sticky left-0 bottom-0 w-full "
    >
      <div sm={2} className=" flex items-center justify-around">
        {nav.map((e, i) => (
          <NavLink key={i} to={e.link}>
            <div className="flex flex-col items-center justify-center gap-1">
              <e.icon size={25} />
              <p className="text-sm max-xs:text-[12px]">{e.name}</p>
            </div>
          </NavLink>
        ))}
      </div>
    </Row>
  );
};
export default NavFooter;
